// /**
//  * driver-shift
//  */

// React
import React, {useEffect, useState} from 'react';

// UI
import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';
import {
  CircularProgress,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Checkbox,
  Button,
  Grid,
  TextField,
} from '@material-ui/core';

// Type
import {DriverShift} from './interfaces';
import {getDriverShiftsAction, updateDriverShiftsAction} from './actions';
import {connect} from 'react-redux';
import {compose} from 'redux';
import {createStructuredSelector} from 'reselect';
import {Store} from '../../redux/reducers';
import {
  makeSelectDriverShifts,
  makeSelectDriverShiftsLoading,
  makeSelectError,
} from './selectors';
import theme from '../../theme';

type Props = {
  driverShifts: DriverShift;
  match: {
    params: {
      id: number;
      shiftId: number;
    };
  };
  loading: boolean;
  handleClose: () => void;
  updateDriverShiftsDispatch: (payload: {body: DriverShift}) => void;
  getDriverShiftsDispatch: (id: number) => void;
};

export interface SelectorProps {
  driverShifts: DriverShift;
  driverShiftsLoading: boolean;
  error: any;
}

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    loading: {
      display: 'flex',
      justifyContent: 'center',
    },
    table: {
      minWidth: 650,
    },
    errorText: {
      color: '#F30000',
      fontSize: '11px',
    },
    root: {
      width: '100%',
    },
    container: {
      maxHeight: '80vh',
      borderRadius: '4px',
    },
  })
);

// Const
const Rows = Array.from(Array(24).keys());
const Days = [
  'شنبه',
  'یکشنبه',
  'دوشنبه ',
  'سه‌شنبه',
  'چهارشنبه',
  'پنج‌شنبه ',
  'جمعه',
];

function DriverShifts(props: Props) {
  const classes = useStyles();
  const [arrayAvailabilityPattern, setArrayAvailabilityPattern] = useState(
    [] as string[]
  );
  const [name, setName] = useState('');

  useEffect(() => {
    props.driverShifts.availabilityPattern &&
      handleSetAvailabilityPattern(props.driverShifts.availabilityPattern);

    if (props.driverShifts?.name) {
      setName(props.driverShifts.name);
    }
  }, [props.driverShifts]);

  useEffect(() => {
    if (String(props.match.params.shiftId) === 'null') {
      setName('');
      handleSetAvailabilityPattern(
        '000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000'
      );
    }
  }, []);

  const handleSetAvailabilityPattern = (availabilityPattern: string) => {
    const lengthAvailabilityPattern: number = availabilityPattern?.length;
    const genarateAvailabilityPattern: string = new Array(
      168 - lengthAvailabilityPattern + 1
    ).join('0'); // handle when availabilityPattern.length < 168
    const newAvailabilityPattern = availabilityPattern?.concat(
      '',
      genarateAvailabilityPattern
    );
    setArrayAvailabilityPattern(Array.from(newAvailabilityPattern));
  };

  const handleChangeShift = (
    event: React.ChangeEvent<HTMLInputElement>,
    index: any,
    time: any
  ) => {
    arrayAvailabilityPattern[time + index * 24] = event.target.checked
      ? '1'
      : '0';
    setArrayAvailabilityPattern([...arrayAvailabilityPattern]);
  };

  const handleUpdate = () => {
    const availabilityPattern = arrayAvailabilityPattern
      .toString()
      .replace(/,/g, '');
    const body =
      String(props.match.params.shiftId) === 'null'
        ? {...{name}, availabilityPattern}
        : {...{name}, ...props.driverShifts, availabilityPattern};

    props.updateDriverShiftsDispatch({
      body,
      id: props.match.params.id,
      callback: () => {
        window.history.back();
      },
    });
  };

  const handleOpenShift = () => {
    const {id, shiftId} = props.match.params;
    props.getDriverShiftsDispatch(shiftId);
  };

  useEffect(() => {
    if (String(props.match.params.shiftId) !== 'null') handleOpenShift();
  }, []);

  return (
    <div>
      {props.loading ? (
        <div className={classes.loading}>
          <CircularProgress />
        </div>
      ) : (
        <>
          <div
            style={{
              width: '100%',
              margin: '10px 0',
              padding: '10px',
              backgroundColor: 'white',
            }}
          >
            <TextField
              style={{width: '50%'}}
              type="text"
              id="name"
              name="name"
              variant="outlined"
              color="secondary"
              size="medium"
              label="نام شیفت"
              value={name}
              onChange={e => setName(e.target.value)}
            />
            {name.length === 0 && (
              <p className={classes.errorText}>{'فیلد نام شیفت الزامیست'}</p>
            )}
            {name.length !== 0 && name.length < 5 && (
              <p className={classes.errorText}>
                {'مقدار نام شیفت نباید کمتر از 5 کاراکتر باشد'}
              </p>
            )}
            {name.length !== 0 && name.length > 25 && (
              <p className={classes.errorText}>
                {'مقدار نام شیفت نباید بیشتر از 25 کاراکتر باشد'}
              </p>
            )}
          </div>
          <TableContainer component={Paper} className={classes.container}>
            <Table
              className={classes.table}
              stickyHeader
              aria-label="sticky table"
            >
              <TableHead>
                <TableRow>
                  <TableCell
                    style={{
                      backgroundColor: theme.palette.primary.main,
                      color: 'white',
                    }}
                  ></TableCell>
                  {Days.map((day: string, index: number) => {
                    return (
                      <TableCell
                        align="center"
                        key={index}
                        style={{
                          backgroundColor: theme.palette.primary.main,
                          color: 'white',
                        }}
                      >
                        {' '}
                        {day}
                      </TableCell>
                    );
                  })}
                </TableRow>
              </TableHead>

              <TableBody>
                {Rows.map((_, index) => {
                  const newAvilable = arrayAvailabilityPattern.slice();

                  return (
                    <TableRow key={index}>
                      <TableCell component="th" scope="row">
                        {`00: ${index < 10 ? `0${index}` : index}`}
                      </TableCell>
                      {Days.map((_, indexDays: number) => {
                        return (
                          <TableCell align="center" key={indexDays}>
                            {
                              <Checkbox
                                checked={
                                  newAvilable[indexDays * 24 + index] === '1'
                                }
                                onChange={e =>
                                  handleChangeShift(e, indexDays, index)
                                }
                                color="secondary"
                                inputProps={{
                                  'aria-label': 'secondary checkbox',
                                }}
                              />
                            }
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>

          <Grid
            container
            spacing={2}
            direction="row-reverse"
            alignItems="center"
            style={{marginTop: '20px'}}
          >
            <Grid item xs={1}>
              <Button
                variant="outlined"
                color="primary"
                fullWidth
                onClick={handleUpdate}
              >
                {'تغییر شیفت'}
              </Button>
            </Grid>
            <Grid item xs={1}>
              <Button
                variant="contained"
                onClick={() => window.history.back()}
                color="primary"
                fullWidth
              >
                {'بازگشت'}
              </Button>
            </Grid>
          </Grid>
        </>
      )}
    </div>
  );
}

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  driverShifts: makeSelectDriverShifts(),
  driverShiftsLoading: makeSelectDriverShiftsLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    getDriverShiftsDispatch: (id: number) =>
      dispatch(getDriverShiftsAction({id})),
    updateDriverShiftsDispatch: (payload: {
      body: DriverShift;
      id: number;
      callback: () => void;
    }) => dispatch(updateDriverShiftsAction(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(DriverShifts);
